import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBookmark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
		fill: "#E7F4FF"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M25.8327 27.5L19.9993 23.3333L14.166 27.5V14.1667C14.166 13.7246 14.3416 13.3007 14.6542 12.9882C14.9667 12.6756 15.3907 12.5 15.8327 12.5H24.166C24.608 12.5 25.032 12.6756 25.3445 12.9882C25.6571 13.3007 25.8327 13.7246 25.8327 14.1667V27.5Z",
		stroke: "#2171C6",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgBookmark;
